import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { useTranslation } from "@coworker/locales";
import type { Team } from "./types";

interface TeamsListProps {
  teams: Team[];
  selectedTeamId: string | undefined;
  onSelect: (teamId: string) => void;
}

export function TeamsList({ teams, selectedTeamId, onSelect }: TeamsListProps) {
  const { t } = useTranslation();

  return (
    <FixaListView id="move-users-to-team-list" size="medium" showDivider>
      {teams.map((team) => (
        <FixaListViewItem
          id={team.id}
          key={team.id}
          data-testid={`move-users-to-team-item-${team.id}`}
          control="radiobutton"
          title={team.name}
          description={t("teamMembersCountString", { count: team.memberCount })}
          size="medium"
          inset
          onChange={() => onSelect(team.id)}
          controlProps={{
            checked: team.id === selectedTeamId,
            value: team.name,
          }}
        />
      ))}
    </FixaListView>
  );
}
